document.addEventListener("DOMContentLoaded", () => {
  // 전체 실행
  prdInfoTabs();
  controlPolicyModal();
  initVariantDropdowns();
  initRecommendationsSlider();

  // pc에서만 실행 — 이 테마 전역에서 MO/PC 판정에 쓰는 기준(767.4999px,
  // prdInfoTabs()의 isMobile과 동일)으로 통일. 이전엔 네이티브 그리드가
  // min-width:750px에서 켜진다는 이유로 여기만 750을 썼었는데, 그러면
  // 이 파일 안에서조차 기준이 750/767.4999로 제각각이 되고, 사이트
  // 전체가 쓰는 767.4999 기준과도 어긋나서 오히려 더 혼란스러웠음 —
  // 실제 원인이었던 건 750~767 사각지대가 아니라 .page-wrapper 스크롤
  // 컨테이너 감지 쪽이었어서(아래 initProductInfoSticky 참고), 여기는
  // 그냥 사이트 표준 기준 하나로 통일.
  if (window.innerWidth > 767.4999) {
    initProductInfoSticky();
  } else {
    // MO에서만 실행
    initMobileBuyBar();
  }
});

// 프로덕트 인포 탭
function prdInfoTabs() {
  const roots = document.querySelectorAll('[data-dc-ptabs="true"]');
  if (!roots.length) return;

  const isMobile = window.matchMedia("(max-width: 767.4999px)").matches;

  roots.forEach((root) => {
    // 중복 init 방지
    if (root.dataset.dcPtabsInit === "true") return;
    root.dataset.dcPtabsInit = "true";

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    const head = root.querySelector('[data-dc-component="ptabs-head"]');

    const scrollTabIntoViewX = (tabBtn) => {
      if (!isMobile) return;
      if (!head || !tabBtn) return;

      // 헤드(스크롤 컨테이너) 기준으로 탭 버튼을 "가운데"로 오게 스크롤
      const headRect = head.getBoundingClientRect();
      const tabRect = tabBtn.getBoundingClientRect();

      const headCenter = headRect.left + headRect.width / 2;
      const tabCenter = tabRect.left + tabRect.width / 2;

      const delta = tabCenter - headCenter; // +면 오른쪽으로 더 가야 함
      const targetLeft = head.scrollLeft + delta;

      head.scrollTo({
        left: targetLeft,
        behavior: "smooth",
      });
    };

    const setActive = (tabKey) => {
      tabs.forEach((t) => {
        const isActive = t.dataset.tab === tabKey;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-selected", isActive ? "true" : "false");
        t.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach((p) =>
        p.classList.toggle("is-active", p.dataset.panel === tabKey)
      );
      // 숨겨져 있던 패널은 폭이 0이라 측정이 안 됨 — 보일 때 접기.
      clampPtabsItems(root);
    };

    root.addEventListener("click", (e) => {
      const tabBtn = e.target.closest('[data-dc-action="ptabs-tab"][role="tab"]');
      if (tabBtn && root.contains(tabBtn)) {
        setActive(tabBtn.dataset.tab);
        scrollTabIntoViewX(tabBtn); // ✅ 추가: 모바일에서만 X 스크롤 이동
        return;
      }

      const openBtn = e.target.closest('[data-dc-open-ingredients-modal="true"]');
      if (openBtn) {
        const modal = root.querySelector("dialog.dc-modal");
        if (modal?.showModal) modal.showModal();
        else modal?.setAttribute("open", "true");
        return;
      }

      const closeBtn = e.target.closest('[data-dc-close-modal="true"]');
      if (closeBtn) {
        const modal = root.querySelector("dialog.dc-modal");
        if (modal?.close) modal.close();
        else modal?.removeAttribute("open");
        return;
      }
    });

    const modal = root.querySelector("dialog.dc-modal");
    if (modal) {
      modal.addEventListener("click", (e) => {
        const inner = modal.querySelector(".dc-modal__inner");
        if (inner && !inner.contains(e.target)) {
          if (modal.close) modal.close();
          else modal.removeAttribute("open");
        }
      });
    }

    const defaultTab = tabs.find((t) => t.dataset.tab === "benefits") || tabs[0];
    if (defaultTab) {
      setActive(defaultTab.dataset.tab);
      // 초기 로딩 시에도 모바일이면 active 탭이 보이도록 정렬
      scrollTabIntoViewX(defaultTab);
    }
  });
}


// (MO) 製品説明 / 使用方法 항목 접기 (Figma 350:1804)
// '。' 기준으로 첫 문장까지만 보여주고 뒤에 "···もっと表示":
//   1. 한 줄(=한 문장)이고 두 줄 안이면 그대로
//   2. 첫 문장이 두 줄을 넘으면, 두 줄 안에 들어가는 만큼 + "···もっと表示"
//   3. 첫 문장이 두 줄 안이고 뒤에 문장이 더 있으면, 첫 문장 + "···もっと表示"
// 누르면 그 항목 전체를 펼침. PC는 항상 전체.
// 항목 원래 마크업은 텍스트 요소의 dcFullHTML에 보관하고, 폭이 바뀌면
// (회전 등) 접힌 항목만 다시 계산.
const dcPtabsMobile = window.matchMedia("(max-width: 767.4999px)");
const DC_PTABS_LINES = 2;

// 접을 텍스트 요소: 使用方法은 .dc-ptabs__numbered-text, 製品説明은 li 안
// 내용을 span으로 감싼 것(li는 flex라 버튼이 따로 떨어지지 않게).
function ptabsTextTargets(root) {
  root.querySelectorAll(".dc-ptabs__list-item").forEach((li) => {
    if (li.querySelector(":scope > .dc-ptabs__item-text")) return;
    const span = document.createElement("span");
    span.className = "dc-ptabs__item-text";
    span.append(...li.childNodes);
    li.appendChild(span);
  });
  return root.querySelectorAll(".dc-ptabs__item-text, .dc-ptabs__numbered-text");
}

function makePtabsMore(el) {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "dc-ptabs__more";
  button.setAttribute("aria-expanded", "false");
  button.innerHTML = '<span aria-hidden="true">···</span><span class="dc-ptabs__more-label">もっと表示</span>';
  button.addEventListener("click", () => {
    el.dataset.dcExpanded = "true";
    el.innerHTML = el.dcFullHTML;
  });
  return button;
}

function collapsePtabsItem(el) {
  if (el.dcFullHTML === undefined) el.dcFullHTML = el.innerHTML;
  el.innerHTML = el.dcFullHTML;
  if (!dcPtabsMobile.matches || el.dataset.dcExpanded === "true") return;

  const max = parseFloat(getComputedStyle(el).lineHeight) * DC_PTABS_LINES + 1;
  const text = el.textContent.trim();
  const end = text.indexOf("。");
  const sentence = end === -1 ? text : text.slice(0, end + 1);
  const hasRest = text.slice(sentence.length).trim() !== "";
  if (!hasRest && el.scrollHeight <= max) return; // 1

  const textNode = document.createTextNode(sentence);
  el.replaceChildren(textNode, makePtabsMore(el));
  if (el.scrollHeight <= max) return; // 3

  // 2: 두 줄 안에 들어가는 가장 긴 앞부분
  let lo = 0;
  let hi = sentence.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    textNode.data = sentence.slice(0, mid);
    if (el.scrollHeight <= max) lo = mid;
    else hi = mid - 1;
  }
  textNode.data = sentence.slice(0, lo);
}

function clampPtabsItems(root) {
  ptabsTextTargets(root).forEach((el) => {
    if (!el.clientWidth) return; // 숨은 패널 — 탭을 열 때 다시
    if (el.dcClampWidth === el.clientWidth && el.dcClampMobile === dcPtabsMobile.matches) return;
    el.dcClampWidth = el.clientWidth;
    el.dcClampMobile = dcPtabsMobile.matches;
    collapsePtabsItem(el);
  });
}

function refreshPtabsItems() {
  document.querySelectorAll('[data-dc-ptabs="true"]').forEach(clampPtabsItems);
}

dcPtabsMobile.addEventListener("change", refreshPtabsItems);
let dcPtabsResizeTimer = null;
window.addEventListener("resize", () => {
  clearTimeout(dcPtabsResizeTimer);
  dcPtabsResizeTimer = setTimeout(refreshPtabsItems, 150);
});
// 웹폰트가 늦게 적용되면 줄 수가 달라지므로 한 번 더.
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => {
    document.querySelectorAll(".dc-ptabs__item-text, .dc-ptabs__numbered-text").forEach((el) => {
      el.dcClampWidth = null;
    });
    refreshPtabsItems();
  });
}

// 배송정책 모달
function controlPolicyModal(){
  const roots = document.querySelectorAll('[data-dc-component="policy-modal"]');
  if (!roots.length) return;
  roots.forEach((root) => {
    const dialog = root.querySelector("dialog");
    if (!dialog) return;

    const openBtn = root.querySelector('[data-dc-action="open"]');
    const closeBtn = root.querySelector('[data-dc-action="close"]');

    openBtn?.addEventListener("click", () => {
      if (!dialog.open) dialog.showModal();
    });

    closeBtn?.addEventListener("click", () => {
      if (dialog.open) dialog.close();
    });

    dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      dialog.close();
    }
  });
  });
}

// (PC) dc-product-info__details → fixed
// #__pf(리뷰 위젯)처럼 앱이 비동기로 그려 넣는 특정 요소에 더 이상
// 의존하지 않음 — 대신 항상 동기적으로 존재하는 #MainContent, details
// 자신의 부모(=그리드 컨테이너, 네이티브 position:sticky가 적용되는 바로
// 그 요소), 그리고 .dc-detail-image-section(상세이미지 섹션)만 기준으로
// 삼는다. 리뷰 구간에서는 안 따라오다가(fixed 안 걸림), 상세이미지
// 섹션에서만 다시 fixed로 따라붙고, 그 섹션이 끝나면(다음 섹션이
// 시작되면) 풀어줌 — 그 아래 콘텐츠(Benefit 등)까지는 안 따라감.
function initProductInfoSticky() {
  const targets = document.querySelectorAll(
    '[data-dc-component="product-info-sticky"]'
  );
  if (!targets.length) return;

  const mainContent = document.querySelector("#MainContent");
  if (!mainContent) return;

  // 이 테마는 데스크톱(>=990px)에서 html/body를 100dvh + overflow:hidden으로
  // 고정하고, .page-wrapper가 자체 overflow-y:auto로 실제 스크롤을 담당한다
  // (assets/base.css). 그 미만에서는 window가 담당. 이 경계는 우리가 쓰는
  // 750/767.4999 기준과 다른, 네이티브 쪽의 별도 기준이라 손댈 수 없음 —
  // 대신 matchMedia로 반응형 감지해서, 넓은 화면에서 로드한 뒤 좁게
  // 리사이즈해도(또는 그 반대) 항상 실제로 스크롤되는 컨테이너를 계속
  // 따라가도록 함. (한 번만 판별하던 이전 방식은 리사이즈로 990px
  // 경계를 넘으면 죽은 컨테이너를 계속 참조해서 기능이 멈췄었음.)
  const pageWrapperQuery = window.matchMedia("(min-width: 990px)");
  const pageWrapper = document.querySelector(".page-wrapper");

  function currentScrollContainer() {
    return pageWrapperQuery.matches && pageWrapper ? pageWrapper : null;
  }

  let scrollContainer = currentScrollContainer();
  const scrollHandlers = [];

  function attachScrollHandler(handler) {
    scrollHandlers.push(handler);
    (scrollContainer || window).addEventListener("scroll", handler, { passive: true });
  }

  pageWrapperQuery.addEventListener("change", () => {
    const nextContainer = currentScrollContainer();
    if (nextContainer === scrollContainer) return;

    scrollHandlers.forEach((handler) => {
      (scrollContainer || window).removeEventListener("scroll", handler);
    });
    scrollContainer = nextContainer;
    scrollHandlers.forEach((handler) => {
      (scrollContainer || window).addEventListener("scroll", handler, { passive: true });
      handler();
    });
  });

  function getScrollTop() {
    return scrollContainer ? scrollContainer.scrollTop : window.scrollY;
  }

  function docTop(target) {
    return target.getBoundingClientRect().top + getScrollTop();
  }

  function docBottom(target) {
    return target.getBoundingClientRect().bottom + getScrollTop();
  }

  targets.forEach((el) => {
    if (el.dataset.dcStickyInit === "1") {
      console.log("[dc-sticky] already initialized, skipping");
      return;
    }
    el.dataset.dcStickyInit = "1";

    const topOffset = Number(el.getAttribute("data-dc-option-top") || 0);
    const buffer = Number(el.getAttribute("data-dc-option-buffer") || 12); // jitter 방지

    const parent = el.parentElement;
    if (!parent) return;

    // el(details)의 부모는 product-information__grid 자체(CSS Grid,
    // 컬럼 2개, media/details가 소스 순서로 auto-placement됨). spacer를
    // 그 grid의 형제로 바로 끼워 넣으면 grid item이 3개(media, spacer,
    // details)가 돼서 auto-placement가 밀리고 details가 다음 행으로
    // 넘어가 버리는 버그가 있었음(우측 패널이 이미지 아래로 떨어져
    // 보이던 원인). el을 별도 래퍼로 감싸서 grid item은 그대로 1개만
    // 유지하고, spacer는 그 래퍼 안(grid 바깥)에 둔다.
    const wrapper = document.createElement("div");
    wrapper.dataset.dcStickyWrapper = "1";
    parent.insertBefore(wrapper, el);
    wrapper.appendChild(el);

    // spacer (자리 유지)
    const spacer = document.createElement("div");
    spacer.setAttribute("aria-hidden", "true");
    spacer.dataset.dcStickySpacer = "1";
    spacer.style.height = "0px";
    wrapper.insertBefore(spacer, el);

    let state = "normal"; // normal | abs | fixed
    let ticking = false;
    let detailsHeight = 0;

    function measureHeights() {
      detailsHeight = Math.ceil(el.getBoundingClientRect().height);
    }

    // .product-information(상단 갤러리+구매박스 섹션 전체)이 화면에서
    // 완전히 사라지는 시점 — 여기까지는 기존 sticky_details_desktop
    // (position:sticky) 동작 그대로 두고, 이 지점부터 abs 단계 시작.
    const productInfoSection = parent.closest(".product-information");

    function productInfoBottomInDoc() {
      return productInfoSection ? docBottom(productInfoSection) : docBottom(parent);
    }

    // 상세페이지 이미지 섹션(product.metafields.custom.detail_images).
    // 메타필드가 비어서 섹션 자체가 없으면 abs 단계 없이 productInfo가
    // 사라지자마자 바로 fixed로 폴백.
    const detailImageSection = document.querySelector(".dc-detail-image-section");

    function fixedStartYInDoc() {
      if (detailImageSection) {
        return docTop(detailImageSection) - topOffset;
      }
      return productInfoBottomInDoc() - topOffset;
    }

    // abs 상태일 때 top 값 — .product-information이 position:relative라
    // 그 기준 상대 좌표로 변환. abs로 있는 동안 상세이미지 섹션 상단과
    // 같은 문서 좌표에 고정돼 있다가, 스크롤이 그 지점에 닿으면(=
    // fixedStartYInDoc) 화면상 정확히 같은 자리에서 fixed로 이어받음
    // (점프 없음).
    function absTopInDoc() {
      if (!productInfoSection || !detailImageSection) return 0;
      return docTop(detailImageSection) - docTop(productInfoSection);
    }

    // 상세이미지 섹션이 끝나는 지점(=다음 섹션이 시작되는 지점)에서
    // 풀어줌 — 그 아래(Benefit, Ingredients & BtoA 등)까지는 안 따라옴.
    // 메타필드가 비어서 섹션 자체가 없으면 #MainContent 바닥까지로 폴백.
    function releaseYInDoc() {
      if (detailImageSection) {
        return docBottom(detailImageSection);
      }
      return docBottom(mainContent);
    }

    function lockParentHeight() {
      // wrapper(grid item)가 el 없이도 자리를 유지하도록, el의 원래
      // 높이만큼 spacer 높이를 맞춘다.
      spacer.style.height = `${detailsHeight}px`;
    }

    function unlockHeight() {
      spacer.style.height = "0px";
    }

    function measureFixedVars() {
      el.style.setProperty("--dc-sticky-top", `${topOffset}px`);
    }

    function setState(next) {
      if (state === next) return;
      console.log("[dc-sticky] state change:", state, "->", next);
      const prevState = state;
      state = next;

      // normal → abs/fixed로 갑자기 나타날 때만 부자연스러운 "팝인"이
      // 보임 (abs → fixed는 같은 화면 좌표를 이어받게 이미 계산해둬서
      // 점프가 없음). 그 경우에만 opacity를 0으로 깔아둔 뒤 다음
      // 프레임에 1로 돌려서, 이미 제자리에 있는 상태로 살짝 페이드인
      // 되게 함(위치 자체를 애니메이션하면 지터가 생겨서 opacity만 사용).
      const shouldFadeIn = prevState === "normal" && next !== "normal";
      if (shouldFadeIn) el.style.opacity = "0";

      if (next === "fixed") {
        lockParentHeight();
        measureHeights();
        measureFixedVars();
        el.style.removeProperty("--dc-abs-top");
        el.setAttribute("data-dc-state", "fixed");

        requestAnimationFrame(() => {
          if (state !== "fixed") return;
          lockParentHeight();
          measureHeights();
          measureFixedVars();
        });
      } else if (next === "abs") {
        lockParentHeight();
        measureHeights();
        el.style.removeProperty("--dc-sticky-top");
        el.style.setProperty("--dc-abs-top", `${absTopInDoc()}px`);
        el.setAttribute("data-dc-state", "abs");
      } else {
        el.removeAttribute("data-dc-state");
        el.style.removeProperty("--dc-sticky-top");
        el.style.removeProperty("--dc-abs-top");
        el.style.removeProperty("opacity");
        unlockHeight();
      }

      if (shouldFadeIn) {
        requestAnimationFrame(() => {
          el.style.opacity = "1";
        });
      }
    }

    function computeNextState() {
      const y = getScrollTop();

      const absStartY = productInfoBottomInDoc() - topOffset;
      const fixedStartY = fixedStartYInDoc();
      const endY = releaseYInDoc() - topOffset - detailsHeight;

      // TEMP DEBUG — 콘솔에서 window.__dcStickyDebug 확인
      window.__dcStickyDebug = {
        state,
        scrollContainer: scrollContainer ? ".page-wrapper" : "window",
        scrollY: y,
        absStartY,
        fixedStartY,
        endY,
        detailsHeight,
        productInfoSectionFound: !!productInfoSection,
        productInfoTop: productInfoSection ? docTop(productInfoSection) : null,
        productInfoBottom: productInfoSection ? docBottom(productInfoSection) : null,
        detailImageSectionFound: !!detailImageSection,
        detailImageTop: detailImageSection ? docTop(detailImageSection) : null,
        absTopValue: absTopInDoc(),
        elRect: el.getBoundingClientRect().top,
        elComputedTop: getComputedStyle(el).top,
      };

      // 아래쪽 콘텐츠가 details보다 짧은 극단 케이스 방어
      if (endY <= fixedStartY) return "normal";

      if (y < absStartY) return "normal";
      if (detailImageSection && y < fixedStartY) return "abs";
      if (y < endY - buffer) return "fixed";
      return "normal";
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        // end 계산에 height가 필요하니까 매 프레임은 아니더라도 스크롤마다 갱신
        measureHeights();
        setState(computeNextState());

        // abs 상태일 때 --dc-abs-top을 매 프레임 다시 계산 — 리뷰
        // 위젯(Yotpo)이 비동기로 늦게 로드되면서 그 아래 상세이미지
        // 섹션의 문서상 위치가 abs 진입 이후에도 계속 바뀔 수 있는데,
        // setState()는 상태가 "바뀔 때"만 한 번 쓰기 때문에 그 뒤에
        // 위치가 밀리면 값이 그대로 굳어서 위치가 어긋났었음.
        if (state === "abs") {
          el.style.setProperty("--dc-abs-top", `${absTopInDoc()}px`);
        }

        ticking = false;
      });
    }

    function onResize() {
      // 리사이즈 시 기준/폭/높이 재정렬
      measureHeights();
      if (state === "fixed") {
        lockParentHeight();
        measureFixedVars();
      } else if (state === "abs") {
        lockParentHeight();
        el.style.setProperty("--dc-abs-top", `${absTopInDoc()}px`);
      }
      onScroll();
    }

    attachScrollHandler(onScroll);
    window.addEventListener("resize", onResize);

    // 리뷰 위젯(Yotpo) 같은 앱이 스크롤 없이 가만히 있는 동안에도
    // 비동기로 늦게 로드되면서 #MainContent 높이를 바꿀 수 있음 — 그때도
    // onScroll을 다시 돌려서 경계값/--dc-abs-top을 최신 상태로 맞춘다.
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => onScroll());
      resizeObserver.observe(mainContent);
    }

    // 초기 동기화
    measureHeights();
    onScroll();
  });
}

// 옵션 드롭다운 커스텀 UI
// 네이티브 <select>는 기능(값 변경 → variant-picker의 change 이벤트 → 섹션
// 갱신)을 위해 그대로 두고, 시안처럼 보이도록 그 위에 커스텀 목록(패널)을
// 얹는다. 옵션을 바꾸면 Shopify가 variant-picker 내부를 서버 응답으로
// 모프(morph)해서 다시 그리는데, 그 결과물엔 우리가 넣은 패널이 없으니
// 매번 사라진다 — MutationObserver로 그 시점을 감지해서 패널을 재생성한다.
let dcVariantDropdownSelfMutating = false;
let dcVariantDropdownListenersInit = false;

function buildVariantDropdownPanel(root) {
  const wrapper = root.querySelector(".variant-option__select-wrapper");
  if (!wrapper) return;

  const select = wrapper.querySelector("select.variant-option__select");
  if (!select) return;

  wrapper.classList.add("dc-variant-dropdown__wrapper--enhanced");
  wrapper.setAttribute("role", "button");
  wrapper.setAttribute("tabindex", "0");
  wrapper.setAttribute("aria-haspopup", "listbox");
  wrapper.setAttribute("aria-expanded", "false");

  const existingPanel = root.querySelector(".dc-variant-dropdown__panel");
  if (existingPanel) existingPanel.remove();

  const panel = document.createElement("ul");
  panel.className = "dc-variant-dropdown__panel";
  panel.setAttribute("role", "listbox");
  panel.hidden = true;

  Array.from(select.options).forEach((option, index) => {
    const row = document.createElement("li");
    row.className = "dc-variant-dropdown__row";
    row.setAttribute("role", "option");
    row.dataset.dcOptionIndex = String(index);
    row.setAttribute("aria-selected", option.selected ? "true" : "false");
    if (option.selected) row.classList.add("is-selected");
    row.textContent = option.textContent.trim();
    panel.appendChild(row);
  });

  root.appendChild(panel);
}

function closeAllVariantDropdownPanels() {
  document.querySelectorAll(".dc-variant-dropdown__panel").forEach((panel) => {
    panel.hidden = true;
    const wrapper = panel
      .closest(".dc-variant-dropdown")
      ?.querySelector(".variant-option__select-wrapper");
    wrapper?.setAttribute("aria-expanded", "false");
    wrapper?.classList.remove("dc-variant-dropdown__wrapper--open");
  });
}

function initVariantDropdowns() {
  const roots = document.querySelectorAll(".dc-variant-dropdown");
  if (!roots.length) return;

  dcVariantDropdownSelfMutating = true;
  roots.forEach(buildVariantDropdownPanel);
  requestAnimationFrame(() => {
    dcVariantDropdownSelfMutating = false;
  });

  // 위임 리스너/옵저버는 한 번만 등록
  if (dcVariantDropdownListenersInit) return;
  dcVariantDropdownListenersInit = true;

  document.addEventListener("click", (e) => {
    const row = e.target.closest(".dc-variant-dropdown__row");
    if (row) {
      const root = row.closest(".dc-variant-dropdown");
      const select = root?.querySelector("select.variant-option__select");
      const index = Number(row.dataset.dcOptionIndex);

      if (select && select.selectedIndex !== index) {
        select.selectedIndex = index;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
      closeAllVariantDropdownPanels();
      return;
    }

    const trigger = e.target.closest(
      ".dc-variant-dropdown .variant-option__select-wrapper"
    );
    if (trigger) {
      // label의 for="select id"가 기본 동작으로 네이티브 select에 포커스를
      // 넘겨서 자체 드롭다운을 열려고 시도할 수 있음 — 커스텀 패널만
      // 쓰도록 막는다.
      e.preventDefault();

      const root = trigger.closest(".dc-variant-dropdown");
      const panel = root?.querySelector(".dc-variant-dropdown__panel");
      if (!panel) return;

      const isOpen = !panel.hidden;
      closeAllVariantDropdownPanels();
      if (!isOpen) {
        panel.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        trigger.classList.add("dc-variant-dropdown__wrapper--open");
      }
      return;
    }

    closeAllVariantDropdownPanels();
  });

  document.addEventListener("keydown", (e) => {
    if (!["Enter", " ", "Escape"].includes(e.key)) return;

    if (e.key === "Escape") {
      closeAllVariantDropdownPanels();
      return;
    }

    const trigger = document.activeElement?.closest(
      ".dc-variant-dropdown .variant-option__select-wrapper"
    );
    if (!trigger) return;

    e.preventDefault();
    trigger.click();
  });

  document.querySelectorAll("variant-picker").forEach((picker) => {
    let pending = null;
    const observer = new MutationObserver(() => {
      if (dcVariantDropdownSelfMutating) return;
      clearTimeout(pending);
      pending = setTimeout(initVariantDropdowns, 30);
    });
    observer.observe(picker, { childList: true, subtree: true });
  });
}

// (MO) 하단 구매 바 + 모달
// .product-information(상단 영역)이 화면에서 사라지면 하단에 "購入する"
// 바가 나타나고, 누르면 옵션 선택(.variant-picker)과 수량/담기 버튼
// (.buy-buttons-block)을 모달로 옮겨서 보여준다. PC와 달리 상세이미지
// 섹션이 끝나도 계속 유지되다가, 푸터 영역에 도달하면 사라진다.
// 옵션/수량/버튼은 실제 살아있는 엘리먼트를 모달 안으로 옮겼다가 닫을 때
// 원래 자리로 되돌리는 방식 — 복제하면 name/id가 겹쳐서 폼 제출이 꼬이기
// 때문에 항상 페이지에 하나만 존재하게 유지한다.
function initMobileBuyBar() {
  const detailsEl = document.querySelector(
    '[data-dc-component="product-info-sticky"]'
  );
  if (!detailsEl) return;

  const productInfoSection = detailsEl.closest(".product-information");
  if (!productInfoSection) return;

  const variantPicker = detailsEl.querySelector(".variant-picker");
  const buyButtonsBlock = detailsEl.querySelector(".buy-buttons-block");
  if (!variantPicker && !buyButtonsBlock) return;

  // 원래 위치 표시용 마커 — 모달 닫을 때 이 앞으로 되돌린다. 옵션
  // 드롭다운/담기 버튼 색상 등은 전부 .dc-product-info를 조상으로 하는
  // 선택자로 스타일링돼 있어서(assets/dc-page-product.css), 이 엘리먼트들이
  // body 밑 모달로 옮겨지면 그 스코프를 벗어나 네이티브 기본 스타일로
  // 보이게 된다 — 우측 PC 패널과 똑같이 보이게 하려고 모달 콘텐츠
  // 래퍼에도 같은 클래스를 붙여서 동일한 CSS가 계속 먹게 함.
  const placeholder = document.createElement("div");
  placeholder.setAttribute("aria-hidden", "true");
  placeholder.hidden = true;
  (variantPicker || buyButtonsBlock).before(placeholder);

  const bar = document.createElement("div");
  bar.className = "dc-mobile-buy-bar";
  bar.dataset.dcVisible = "false";

  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = "dc-mobile-buy-bar__button";
  trigger.textContent = "カートに入れる";
  bar.appendChild(trigger);
  document.body.appendChild(bar);

  const modal = document.createElement("dialog");
  modal.className = "dc-mobile-buy-modal";

  // Figma 172:1720 바텀시트: 상단 그래버(손잡이) — 누르거나 아래로
  // 끌어내리면 닫힘(✕ 버튼 대신).
  const grabber = document.createElement("button");
  grabber.type = "button";
  grabber.className = "dc-mobile-buy-modal__grabber";
  grabber.setAttribute("aria-label", "閉じる");

  // 상품 요약(썸네일 + 상품명 + 가격). 상품명은 PDP 타이틀 텍스트,
  // 가격은 PDP 가격 블록을 열 때마다 복사(옵션을 바꾸면 그 가격으로
  // 다시 복사), 이미지는 상품 대표 이미지(og:image).
  const summary = document.createElement("div");
  summary.className = "dc-mobile-buy-modal__product";
  const thumb = document.createElement("div");
  thumb.className = "dc-mobile-buy-modal__thumb";
  const imageUrl =
    document.querySelector('meta[property="og:image:secure_url"]')?.content ||
    document.querySelector('meta[property="og:image"]')?.content;
  if (imageUrl) {
    const img = document.createElement("img");
    try {
      const url = new URL(imageUrl, location.href);
      url.searchParams.set("width", "240");
      img.src = url.toString();
    } catch (e) {
      img.src = imageUrl;
    }
    img.alt = "";
    img.loading = "lazy";
    thumb.appendChild(img);
  }
  const summaryText = document.createElement("div");
  summaryText.className = "dc-mobile-buy-modal__product-text";
  const summaryTitle = document.createElement("p");
  summaryTitle.className = "dc-mobile-buy-modal__title";
  summaryTitle.textContent = (
    detailsEl.querySelector(".dc-product-info__title")?.textContent ||
    document.querySelector('meta[property="og:title"]')?.content ||
    ""
  ).trim();
  const summaryPrice = document.createElement("div");
  summaryPrice.className = "dc-mobile-buy-modal__price";
  summaryText.append(summaryTitle, summaryPrice);
  summary.append(thumb, summaryText);

  const modalContent = document.createElement("div");
  // dc-product-info: 위 주석 참고 — PC 패널과 동일한 CSS가 먹게 하려고 부여.
  modalContent.className = "dc-mobile-buy-modal__inner dc-product-info";
  modalContent.appendChild(summary);

  modal.appendChild(grabber);
  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  function syncPrice() {
    // PDP 가격 마크업을 그대로 복사 — 할인 중이면 할인율/판매가/정상가
    // (취소선) 줄(.dc-price-row, 스타일은 dc-cards.css 공용)이 같이 옴.
    // 세금·배송 안내/수량 할인/단위 가격 문구는 뺌.
    const container = detailsEl.querySelector('.dc-product-info__price [ref="priceContainer"]');
    if (!container) return;
    const copy = container.cloneNode(true);
    copy.removeAttribute("ref");
    copy.querySelectorAll(".tax-note, .volume-pricing-note, .unit-price").forEach((el) => el.remove());
    summaryPrice.replaceChildren(copy);
  }

  // 옵션을 바꾸면 PDP 가격 블록이 새로 그려지므로, 모달이 열려 있는
  // 동안만 그 변화를 따라 다시 복사.
  const priceObserver = new MutationObserver(() => {
    if (modal.open) syncPrice();
  });
  priceObserver.observe(detailsEl, { childList: true, subtree: true, characterData: true });

  // 옵션 변경 이벤트(shopify:product:select) 중계: PDP 가격/갤러리/재고/
  // SKU는 자기 .shopify-section에 리스너를 걸고 있는데, 옵션 선택을
  // 모달(<dialog>, body 직속)로 옮기면 이벤트가 그 섹션을 거치지 않아서
  // 아무것도 안 바뀜(→ 모달 가격도 안 바뀜). 모달에서 올라온 이벤트를
  // 디스패치가 끝난 뒤 같은 이벤트 객체로 섹션에 다시 쏴 줌 — 담기
  // 폼은 모달 안에서 dialog 리스너로 이미 받았으므로 중복 아님.
  // 섹션 위(document)로는 다시 올라가지 않게 섹션에서 끊음.
  const sectionEl = productInfoSection.closest(".shopify-section");
  const RELAYED = "dcRelayedFromBuyModal";
  if (sectionEl) {
    modal.addEventListener("shopify:product:select", (event) => {
      if (event[RELAYED]) return;
      queueMicrotask(() => {
        event[RELAYED] = true;
        sectionEl.dispatchEvent(event);
      });
    });
    sectionEl.addEventListener("shopify:product:select", (event) => {
      if (event[RELAYED]) event.stopPropagation();
    });
  }

  function openModal() {
    syncPrice();
    if (variantPicker) modalContent.appendChild(variantPicker);
    if (buyButtonsBlock) modalContent.appendChild(buyButtonsBlock);
    modal.showModal();
  }

  // 버튼 클릭/ESC/배경 클릭 등 닫히는 경로가 여러 개라, 실제 복구는
  // 전부 여기로 모아서 한 번만 처리 — dialog는 close()가 호출되면
  // 이유와 상관없이 항상 'close' 이벤트를 발생시킨다.
  modal.addEventListener("close", () => {
    if (variantPicker) placeholder.before(variantPicker);
    if (buyButtonsBlock) placeholder.before(buyButtonsBlock);
    modal.style.transform = "";
  });

  // cart-drawer.js는 열린 모달 <dialog> 안에서 담기가 일어나면 그 모달이
  // 닫힐 때까지 드로워 열기를 미룬다(담은 뒤 스스로 닫히는 퀵애드 모달
  // 전제). 이 모달은 스스로 닫히지 않으므로, 담기가 성공하면 직접 닫아서
  // 드로워가 이어서 열리게 한다. 드로워가 거는 close 리스너보다 먼저
  // 닫히지 않도록 한 프레임 뒤에 닫음.
  document.addEventListener("shopify:cart:lines-update", (event) => {
    if (!modal.open || event.action !== "add") return;
    if (!(event.target instanceof Node) || !modal.contains(event.target)) return;

    Promise.resolve(event.promise)
      .then((result) => {
        if (result?.detail?.didError) return;
        requestAnimationFrame(() => modal.close());
      })
      .catch(() => {});
  });

  trigger.addEventListener("click", openModal);
  grabber.addEventListener("click", () => modal.close());

  // 그래버를 아래로 끌어내리면 시트가 따라 내려가고, 일정 거리(80px)
  // 넘게 내리면 닫힘. 덜 내리면 제자리로 돌아감.
  let dragStartY = null;
  let dragDistance = 0;
  grabber.addEventListener(
    "touchstart",
    (e) => {
      dragStartY = e.touches[0].clientY;
      dragDistance = 0;
      modal.style.transition = "none";
    },
    { passive: true }
  );
  grabber.addEventListener(
    "touchmove",
    (e) => {
      if (dragStartY === null) return;
      dragDistance = Math.max(0, e.touches[0].clientY - dragStartY);
      modal.style.transform = "translateY(" + dragDistance + "px)";
    },
    { passive: true }
  );
  grabber.addEventListener("touchend", () => {
    if (dragStartY === null) return;
    dragStartY = null;
    modal.style.transition = "";
    if (dragDistance > 80) modal.close();
    else modal.style.transform = "";
  });
  modal.addEventListener("click", (e) => {
    // dialog 자체를 클릭했다는 건 안쪽 콘텐츠가 아니라 배경(backdrop)을
    // 눌렀다는 뜻 — light-dismiss가 기본 동작이 아니라서 직접 처리.
    if (e.target === modal) modal.close();
  });

  // 푸터 영역에 도달하면(footer 상단이 화면 안으로 들어오면) 바를 숨긴다.
  const footer = document.querySelector("footer");

  function updateBarVisibility() {
    const isPastTop = productInfoSection.getBoundingClientRect().bottom <= 0;
    const footerReached = footer
      ? footer.getBoundingClientRect().top <= window.innerHeight
      : false;
    bar.dataset.dcVisible = isPastTop && !footerReached ? "true" : "false";
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateBarVisibility();
      ticking = false;
    });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  updateBarVisibility();
}

/* 추천 상품 슬라이드 (sections/product-recommendations.liquid)
   The card row is a horizontal scroll-snap strip (dc-page-product.css);
   this adds PC prev/next arrows that scroll it by one card, each hidden at
   its end of the strip (and both when everything fits). The section's
   products arrive later by fetch, so it waits for the cards to appear.
   Arrows are vertically centered on the square card images. */
function initRecommendationsSlider() {
  const CHEVRON =
    '<svg viewBox="0 0 15 15" fill="none" aria-hidden="true">' +
    '<path d="M5.75 3.5L9.75 7.5L5.75 11.5" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(section) {
    const strip = section.querySelector(".resource-list--grid");
    const wrap = section.querySelector(".section-resource-list");
    if (!strip || !wrap || !strip.querySelector(".resource-list__item")) return false;
    if (wrap.querySelector(".dc-rec-arrow")) return true;

    const make = (dir) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "dc-rec-arrow dc-rec-arrow--" + dir;
      button.setAttribute("aria-label", dir === "prev" ? "前へ" : "次へ");
      button.innerHTML = CHEVRON;
      if (dir === "prev") button.querySelector("svg").style.transform = "scaleX(-1)";
      button.addEventListener("click", () => {
        const item = strip.querySelector(".resource-list__item");
        const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : strip.clientWidth;
        strip.scrollBy({ left: dir === "prev" ? -step : step, behavior: "smooth" });
      });
      wrap.appendChild(button);
      return button;
    };
    const prev = make("prev");
    const next = make("next");

    const update = () => {
      const item = strip.querySelector(".resource-list__item");
      if (item) {
        const top = strip.offsetTop + item.getBoundingClientRect().width / 2;
        prev.style.top = next.style.top = top + "px";
      }
      prev.hidden = strip.scrollLeft <= 1;
      next.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
    };
    strip.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
    return true;
  }

  document.querySelectorAll("product-recommendations").forEach((section) => {
    if (setup(section)) return;
    const observer = new MutationObserver(() => {
      if (setup(section)) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
  });
}
